<div>
  <mat-label>{{this.label}}</mat-label>
</div>

<mat-form-field>
  <mat-label>Date</mat-label>
  <input matInput
         [(ngModel)]="this.selectedDate"
         [min]="this.lowerBound"
         [max]="this.upperBound"
         [matDatepicker]="datePicker"
         (click)="datePicker.open()"
         readonly
         required>
  <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
  <mat-datepicker #datePicker></mat-datepicker>
</mat-form-field>

<div class="components" #components>
  <div class="hours roller">
    <button mat-flat-button class="up" (click)="this.increment('h')">
      <mat-icon>keyboard_arrow_up</mat-icon>
    </button>
    <mat-form-field class="centered">
      <mat-label>Hours</mat-label>
      <input matInput required type="tel" pattern="[0-2]?[0-9]" [(ngModel)]="this.hours" min=0 max=23 />
    </mat-form-field>
    <button mat-flat-button class="down" (click)="this.decrement('h')">
      <mat-icon>keyboard_arrow_down</mat-icon>
    </button>
  </div>

  <div class="delimiter">:</div>

  <div class="minutes roller">
    <button mat-flat-button class="up" (click)="this.increment('m')">
      <mat-icon>keyboard_arrow_up</mat-icon>
    </button>
    <mat-form-field class="centered">
      <mat-label>Minutes</mat-label>
      <input matInput required type="tel" pattern="[0-5][0-9]" [(ngModel)]="this.minutes" min=0 max=59 />
    </mat-form-field>
    <button mat-flat-button class="down" (click)="this.decrement('m')">
      <mat-icon>keyboard_arrow_down</mat-icon>
    </button>
  </div>

  <div class="delimiter">:</div>

  <div class="seconds roller">
    <button mat-flat-button class="up" (click)="this.increment('s')">
      <mat-icon>keyboard_arrow_up</mat-icon>
    </button>
    <mat-form-field class="centered">
      <mat-label>Seconds</mat-label>
      <input matInput required type="tel" pattern="[0-5][0-9]" [(ngModel)]="this.seconds" min=0 max=59 />
    </mat-form-field>
    <button mat-flat-button class="down" (click)="this.decrement('s')">
      <mat-icon>keyboard_arrow_down</mat-icon>
    </button>
  </div>
</div>


<div class="delta">{{this.delta}}</div>